import * as React from "react";
import { OnServeLiveScoreboard, OnServeLiveTableHeader, OnServeLiveTableBody } from "../../components";
import { BackgroundImageWrapper } from "../../../../BackgroundImageWrapper";
export class OnServeLiveScoreboardDesktop extends React.PureComponent {
    render() {
        const { header, title, team1Name, team2Name, team1Scores, team2Scores, backgroundImage, onServe, sportId } = this.props;
        return (React.createElement(BackgroundImageWrapper, { style: { backgroundImage: `url(${backgroundImage})` }, className: "rj-scoreboard__live-wrapper" },
            React.createElement(OnServeLiveScoreboard, { sportId: sportId },
                React.createElement(OnServeLiveTableHeader, Object.assign({}, { header, title, sportId })),
                React.createElement(OnServeLiveTableBody, Object.assign({}, { team1Name, team2Name, team1Scores, team2Scores, onServe, sportId })))));
    }
    ;
}
;
//# sourceMappingURL=OnServeLiveScoreboardDesktop.js.map